module.exports = {
	"classes": [
		"events-page",
		"header-dark"
	],
	"title": "Events",
	"metas": {
		"description": "Events page"
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/events-landing/metadata.json
// module id = 1117
// module chunks = 0